
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-use-x-chat-demo-basic","docs-x-sdk-use-x-chat-demo-model"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.zh-CN.md?type=demo')
};